import { render, staticRenderFns } from "./seatBackComponents.vue?vue&type=template&id=17959099&scoped=true&"
import script from "./seatBackComponents.vue?vue&type=script&lang=js&"
export * from "./seatBackComponents.vue?vue&type=script&lang=js&"
import style0 from "./seatBackComponents.vue?vue&type=style&index=0&id=17959099&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17959099",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17959099')) {
      api.createRecord('17959099', component.options)
    } else {
      api.reload('17959099', component.options)
    }
    module.hot.accept("./seatBackComponents.vue?vue&type=template&id=17959099&scoped=true&", function () {
      api.rerender('17959099', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/travel/components/seatBackComponents.vue"
export default component.exports